import { render, staticRenderFns } from "./PickingUpInfo.vue?vue&type=template&id=53b5854c&scoped=true"
import script from "./PickingUpInfo.vue?vue&type=script&lang=js"
export * from "./PickingUpInfo.vue?vue&type=script&lang=js"
import style0 from "./PickingUpInfo.vue?vue&type=style&index=0&id=53b5854c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b5854c",
  null
  
)

export default component.exports